import {
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  Skeleton,
  styled,
  Typography,
} from "@mui/material";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import useFetch from "../../hooks/useFetch";
import peopleAPI from "../../_api/_people";
import { shallowEqual, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProjectShortcutItem from "./ProjectShortcutItem";
import { useTranslation } from "react-i18next";

const LastProjectCard = ({ personId, context, canEditPeople }: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [projectsList, setProjectsList] = useState<any>([]);
  const tokenData = useSelector((state: any) => state.user, shallowEqual);

  const { data, loading } = useFetch(
    peopleAPI.getById(`${personId ? personId : tokenData?.person_id}/projects`)
  );

  useEffect(() => {
    setProjectsList(data?.["hydra:member"]?.[0]?.projectCareers);
  }, [data]);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();

  const { t } = useTranslation("common");

  return (
    <div>
      <Card>
        <CardHeader
          sx={{ pt: 1 }}
          title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="subtitle2">{t("project.recent")}</Typography>
              {(((context === "advisor" || context === "cre") &&
                canEditPeople) ||
                projectsList?.length > 0) && (
                <IconButton onClick={handleMenuOpen}>
                  <MoreHorizIcon />
                </IconButton>
              )}
            </Box>
          }
        />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem
            onClick={() => navigate(`/app/profile/${personId}/projects`)}
          >
            {projectsList?.length > 0 ? t("project.see_all") : t("project.add")}
          </MenuItem>
        </Menu>
        <CardContent
          sx={{
            paddingInline: 2,
            paddingTop: 0,
            paddingBottom: 0,
            display: "flex",
            width: "100%",
            mt: 1,
            flexWrap: "wrap",
          }}
        >
          {!loading ? (
            projectsList?.length > 0 ? (
              projectsList
                ?.slice(0, 3)
                .map((project: any) => (
                  <ProjectShortcutItem item={project} key={project?.id} />
                ))
            ) : (
              <Typography variant="body2" sx={{ opacity: "0.7", ml: 1 }}>
                {t("project.no_project_now")}
              </Typography>
            )
          ) : (
            <SBoxLoader>
              <LoaderItem />
              <LoaderItem />
              <LoaderItem />
            </SBoxLoader>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default LastProjectCard;

const LoaderItem = () => {
  return (
    <SLoaderItem>
      <Skeleton
        variant="circular"
        width={30}
        height={30}
        sx={{ flexShrink: 0 }}
      />
      <TextRoot>
        <Skeleton variant="text" width={100} height={16} />
        <Skeleton variant="text" width={100} height={15} />
      </TextRoot>
    </SLoaderItem>
  );
};

const SLoaderItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  paddingInline: theme.spacing(2),
  paddingTop: 0,
  paddingBottom: 0,
  width: "100%",
  mt: 1,
}));

const SBoxLoader = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

const TextRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
  width: "100%",
}));
